// extracted by mini-css-extract-plugin
export var cardIcon = "_4y-4";
export var checkboxCard = "_4y-0";
export var checkboxCardSelected = "_4y-3";
export var disabled = "_4y-1";
export var outerBorder = "_4y-2";
export var spacerMedium = "_4y-7";
export var spacerSmall = "_4y-6";
export var spacerXsmall = "_4y-5";